<template>
  <v-container v-if="pricesLoaded == true">
    <div class="text-center background text border pt-2">
      <div></div>
      <div class="d-flex justify-content-around">
        <img :src="images.logo" style="width: 80px" alt="" />
        <div>
          <h1 class="mt-5">Sell offers</h1>

          <h4 class="mt-5">{{ worldSelected }}</h4>
        </div>
        <img :src="images.femaleLogo" style="width: 80px" alt="" />
      </div>
      <v-text-field
        v-model="search"
        label="Search Item"
        class="m-4 pt-3"
        dark
        :height="30"
      ></v-text-field>

      <v-container v-if="items" class="text-center">
        <v-data-table
          class="default-text"
          :headers="headers"
          :items="items.data[categorySelected]"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          hide-default-footer
          :items-per-page="1000"
        >
          <template v-slot:[`item`]="{ item }">
            <tr
              class="myrow text-left"
              @click="
                getHistory({
                  itemName: item.itemName,
                  world: worldSelected,
                  time: 0,
                })
              "
            >
              <td class="col-2 text-center">
                <img :src="item.imgUrl" style="width: 32px; height: 32px" />
              </td>
              <td class="col-4">
                {{ item.itemName }}
              </td>

              <td class="col-2 pt-3">
                <p v-if="itemPrices[item.itemName][0].minSellValue == 0">
                  No stock
                </p>
                <p v-else>
                  {{ parseInt(itemPrices[item.itemName][0].minSellValue).toLocaleString('en', {useGrouping:true}) }} gp
                </p>
              </td>

              <td class="col-2 pt-3">
                <p v-if="itemPrices[item.itemName][0].minSellValue == 0">
                  No stock
                </p>
                <p v-else>
                  {{
                    Math.floor(
                      (parseInt(itemPrices[item.itemName][0].minSellValue) *
                        100) /
                        tibiaCoinPrice
                    ) / 100
                  }}
                  tc
                </p>
              </td>
              <td
                v-if="itemPrices[item.itemName].length > 1"
                class="col-2 pt-3"
              >
                <p>
                  {{
                    Math.round(
                      ((parseInt(itemPrices[item.itemName][0].minSellValue) *
                        100) /
                        parseInt(itemPrices[item.itemName][1].minSellValue) -
                        100) *
                        100 
                        
                    ) / 100? Math.round(
                      ((parseInt(itemPrices[item.itemName][0].minSellValue) *
                        100) /
                        parseInt(itemPrices[item.itemName][1].minSellValue) -
                        100) *
                        100 
                        
                    ) / 100 : 0
                  }}
                  %
                </p>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import images from "@/assets/images";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      images: images,
      search: "",
    };
  },
  computed: {
    ...mapState([
      "items",
      "categorySelected",
      "worldSelected",
      "itemPrices",
      "tibiaCoinPrice",
      "pricesLoaded",
      "itemHistory"
    ]),
    headers() {
      return [
        { text: "", value: "img", class: "default-text" },
        { text: "Item", value: "itemName", class: "warning--text" },
        { text: "GP price", class: "warning--text" },
        { text: "TC price", class: "warning--text" },
        { text: "Change", class: "warning--text" },
      ];
    },
  },
  methods: {
    customRowClass() {
      return "background";
    },
    ...mapMutations(["getHistory"]),
    filterOnlyCapsText(value, search, item) {
      item;
      const upperCasedSearch = search.toUpperCase();
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLocaleUpperCase().indexOf(upperCasedSearch) !== -1
      );
    },
  },
};
</script>

<style scoped>

.myChart:hover {
  background-color: rgb(12, 25, 32) !important;
}
.myrow:hover {
  cursor: pointer;
  background-color: rgba(12, 25, 32, 0.25) !important;
}
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147) !important;
}

.default-text {
  font-family: initial !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: rgb(238, 195, 147) !important;
}

.border {
  border-radius: 10px;
}
</style>